import { TECH_FORM_CACHE_MODES } from "../models/tech-form-vessel-cache.constants";
import type { TechFormCacheMode, TechFormVesselCacheIdentity } from "../models/tech-form-vessel-cache.models";

export function getTechFormVesselCacheIdentity(
  value: unknown,
  defaultMode?: TechFormCacheMode,
): TechFormVesselCacheIdentity | null {
  if (!value || typeof value !== "object") return null;
  const identity = value as Record<string, unknown>;
  const mode =
    identity.mode === TECH_FORM_CACHE_MODES.editable || identity.mode === TECH_FORM_CACHE_MODES.completed
      ? identity.mode
      : defaultMode;
  if (!mode) return null;
  if (
    (typeof identity.imoNumber !== "string" && typeof identity.imoNumber !== "number") ||
    !String(identity.imoNumber).trim() ||
    typeof identity.vesselName !== "string" ||
    !identity.vesselName.trim()
  ) {
    return null;
  }
  return { imoNumber: String(identity.imoNumber), vesselName: identity.vesselName, mode };
}

export function getTechFormVesselCacheKey(value: unknown): string | null {
  const identity = getTechFormVesselCacheIdentity(value);
  return identity ? JSON.stringify([identity.mode, identity.imoNumber, identity.vesselName]) : null;
}

export function getLegacyTechFormVesselCacheKey(value: unknown): string | null {
  const identity = getTechFormVesselCacheIdentity(value, "editable");
  return identity ? JSON.stringify([identity.imoNumber, identity.vesselName]) : null;
}
